import { useAuthentication } from '@ecosystem/newron-client-lib';
import { MutateOptions, useMutation, UseMutationOptions } from '@tanstack/react-query';

import { PreferenceAPIFilterPersistenceService } from './PreferenceApiFilterPersistenceService';
import { FilterPersistenceAsyncService } from './FilterPersistenceService';
import { FilterPersistenceResponse } from './Types';

export type DeletePersistedFilterMutateOptions = MutateOptions<FilterPersistenceResponse, unknown, unknown>;

export interface DeletePersistedFilter {
  mutate: (id: string, options?: DeletePersistedFilterMutateOptions) => void;
  data: FilterPersistenceResponse | null;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  isSuccess: boolean;
  reset: () => void;
}

export const UseDeletePersistedFilter = (
  options?: Omit<UseMutationOptions<FilterPersistenceResponse, unknown, string, unknown>, 'mutationKey' | 'mutationFn'>,
  service: FilterPersistenceAsyncService = PreferenceAPIFilterPersistenceService,
): DeletePersistedFilter => {
  const { getAccessToken } = useAuthentication();

  const { data, isPending, isSuccess, isError, error, mutate, reset } = useMutation({
    mutationKey: ['Delete filter'],

    mutationFn: async (id: string) => {
      const userToken = await getAccessToken();
      if (!userToken) {
        throw new Error('Failed to get userToken');
      }
      return service.deleteFilter(userToken, id);
    },

    ...options,
  });

  return {
    data: data ?? null,
    isLoading: isPending,
    isError,
    error,
    mutate,
    isSuccess,
    reset,
  };
};
